import { html, mount } from '../../core/html.js';
import { get } from '../../core/api.js';
import { emptyState } from '../../core/ui.js';
import { rm, fmtTs } from '../../core/format.js';
import { t } from '../../core/i18n.js';
import { workspace } from '../shared/layout.js';
import { walletStrip } from './dashboard.js';

const PLUS = new Set(['HOST_PENDING_EARNING', 'BONUS', 'REFUND_REVERSAL', 'WITHDRAWAL_REVERSAL']);
const MINUS = new Set(['REFUND', 'PENALTY', 'WITHDRAWAL_REQUEST']);

export async function render(main) {
  const body = workspace(main, 'host');
  // `description` setiap entri dijana oleh pelayan dalam bahasa permintaan semasa.
  const [w, tl] = await Promise.all([get('/api/wallet'), get('/api/wallet/transactions')]);
  const pol = w.payout_release_policy;
  mount(body, html`<div class="spread"><h1 style="margin:0">${t('hostnav.earnings')}</h1><a class="btn btn-primary btn-sm" href="#/host/withdrawals">${t('earnings.withdraw_cta')}</a></div>
    <div style="margin-top:14px">${walletStrip(w)}</div>
    <p class="small muted" style="margin-top:10px">${t(`payout_policy.${pol.mode}`, { hours: pol.hours })} ${t('earnings.dispute_hold')}${w.available_earnings_minor < 0 ? ' ' + t('earnings.negative_note') : ''}</p>
    <h2 style="margin-top:20px">${t('earnings.timeline_title')}</h2>
    ${tl.length ? html`<ul class="timeline">${tl.map((x) => {
      const sign = PLUS.has(x.type) || (x.type === 'ADJUSTMENT' && x.amount_minor > 0) ? 'plus' : MINUS.has(x.type) || (x.type === 'ADJUSTMENT' && x.amount_minor < 0) ? 'minus' : '';
      const amount = x.type === 'PENDING_TO_AVAILABLE' ? rm(x.deltas.available_minor || 0) : sign === 'minus' ? '-' + rm(Math.abs(x.amount_minor)) : sign === 'plus' ? '+' + rm(Math.abs(x.amount_minor)) : rm(x.amount_minor);
      return html`<li><span class="date">${fmtTs(x.created_at, false)}</span><span><b>${t(`tx.${x.type}`)}</b>${x.booking_id ? html` <a class="small" href="#/bookings/${x.booking_id}">${x.booking_id}</a>` : ''}<div class="small muted">${x.description}</div>
        <div class="tiny muted">${t('earnings.balance_after', { pending: rm(x.balance_after.pending_minor), available: rm(x.balance_after.available_minor) })}</div></span>
        <span class="amt ${sign}">${amount}</span></li>`;
    })}</ul>` : emptyState(t('earnings.empty_title'), t('earnings.empty_text'))}`);
}
